import * as realSupabaseApi from './supabaseApi';
import * as mockSupabaseApi from './mockSupabaseApi';

// LocalStorage key for mock mode setting
const MOCK_MODE_KEY = 'useMockFoundationsData';

// Check if we should use mock data
export const isMockModeEnabled = (): boolean => {
  // Always return false in production, regardless of localStorage settings
  if (process.env.NODE_ENV === 'production') {
    return false;
  }
  return localStorage.getItem(MOCK_MODE_KEY) === 'true';
};

// Enable or disable mock mode
export const setMockMode = (enabled: boolean): void => {
  localStorage.setItem(MOCK_MODE_KEY, enabled ? 'true' : 'false');
};

// Toggle mock mode
export const toggleMockMode = (): boolean => {
  const newValue = !isMockModeEnabled();
  setMockMode(newValue);
  return newValue;
};

// Get the appropriate API service based on mock mode setting
export const getApiService = () => {
  // Always use real API in production
  if (process.env.NODE_ENV === 'production') {
    return realSupabaseApi;
  }
  // Only use mock data in development if enabled
  return isMockModeEnabled() ? mockSupabaseApi : realSupabaseApi;
};

// Export all methods from the chosen API implementation
export const getAllFoundations = (...args: Parameters<typeof realSupabaseApi.getAllFoundations>) => {
  return getApiService().getAllFoundations(...args);
};

export const searchFoundations = (...args: Parameters<typeof realSupabaseApi.searchFoundations>) => {
  return getApiService().searchFoundations(...args);
};

export const getFoundationById = (...args: Parameters<typeof realSupabaseApi.getFoundationById>) => {
  return getApiService().getFoundationById(...args);
};

export const updateFoundationInfo = (...args: Parameters<typeof realSupabaseApi.updateFoundationInfo>) => {
  return getApiService().updateFoundationInfo(...args);
};

export const refreshData = (...args: Parameters<typeof realSupabaseApi.refreshData>) => {
  return getApiService().refreshData(...args);
};

export const getRegions = (...args: Parameters<typeof realSupabaseApi.getRegions>) => {
  return getApiService().getRegions(...args);
};

export const getFoundationStats = (...args: Parameters<typeof realSupabaseApi.getFoundationStats>) => {
  return getApiService().getFoundationStats(...args);
};
